import React, { useContext, useEffect, useState } from "react";
import { Dialog } from "../../../../../layout";
import { InputAuto } from "../../../../../controls";
import { AppContext } from "../../../../../App";
import { action, API, controller } from "../../../../../api/api";
import { Grid } from "@mui/material";
import AddCatForm from "./AddCatForm";

const InputCategory = ({ values, setValues, handleInpChg, size = "small" }) => {
  const { authUser } = useContext(AppContext);
  const [cats, setCats] = useState([]);
  const [subCats, setSubCats] = useState([]);
  const [isMainCatAdd, setIsMainCatAdd] = useState(false);
  const [showCatForm, setShowCatForm] = useState(false);
  const [newAddingValue, setNewAddingValue] = useState("");

  // Get Categories
  useEffect(() => {
    if (authUser.id) {
      API(controller.Category + action.GetAllMainCatByOrg).get((res) => {
        res &&
          res.status === 200 &&
          setCats([...res.result.map((j) => ({ ...j, label: j.name }))]);
      });
    }
    return () => {};
  }, [authUser]);

  // Get Subcategory
  useEffect(() => {
    if (values.catId) {
      // Get Tags
      API(controller.Category + action.GetAllCatBySubcat).getById(
        values.catId,
        (res) => {
          res &&
            res.status === 200 &&
            setSubCats([...res.result.map((j) => ({ ...j, label: j.name }))]);
        }
      );
    } else {
      setSubCats([]);
      setValues((x) => ({ ...x, subCatId: "" }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.catId]);

  const handleAddNewCat = (val, isMainCat = false) => {
    setNewAddingValue(
      isMainCat ? val : { name: val, parentCatId: values.catId }
    );
    setIsMainCatAdd(isMainCat);
    setShowCatForm(!showCatForm);
  };

  const handleNewCat = (val) => {
    if (val) {
      if (isMainCatAdd) {
        setCats([{ ...val, label: val.name }, ...cats]);
        setValues((j) => ({ ...j, catId: val.id }));
      } else {
        setSubCats([{ ...val, label: val.name }, ...subCats]);
        setValues((j) => ({ ...j, subCatId: val.id }));
      }
      setIsMainCatAdd(false);
      setNewAddingValue("");
    }
  };

  return (
    <>
      <Grid item xs={12} md={4}>
        <InputAuto
          label="Category"
          name="catId"
          value={values.catId}
          onChange={handleInpChg}
          options={cats}
          enableAddBtn={true}
          handleAdd={(val) => handleAddNewCat(val, true)}
          size={size}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <InputAuto
          label="Subcategory"
          name="subCatId"
          value={values.subCatId}
          onChange={handleInpChg}
          options={subCats}
          disabled={values.catId ? false : true}
          enableAddBtn={true}
          handleAdd={(val) => handleAddNewCat(val, false)}
          size={size}
        />
      </Grid>

      {showCatForm && (
        <Dialog show={showCatForm} onClose={false} maxWidth="md">
          <AddCatForm
            {...{
              setShowForm: setShowCatForm,
              isMainCat: isMainCatAdd,
              addingValues: newAddingValue,
              handleResult: handleNewCat,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default InputCategory;
